import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { BoxProps } from './ui';

interface Props extends Pick<BoxProps, 'padding' | 'scrollY' | 'maxHeight'> {}

export const useStyles = makeStyles(({ spacing }) => ({
  container: ({ padding, scrollY, maxHeight }: Props) => ({
    ...(typeof padding === 'number') && { padding: spacing(padding) },
    ...padding && (typeof padding !== 'number') && padding.top && { paddingTop: spacing(padding.top) },
    ...padding && (typeof padding !== 'number') && padding.right && { paddingRight: spacing(padding.right) },
    ...padding && (typeof padding !== 'number') && padding.bottom && { paddingBottom: spacing(padding.bottom) },
    ...padding && (typeof padding !== 'number') && padding.left && { paddingLeft: spacing(padding.left) },
    ...scrollY && {
      overflowY: 'auto',
      maxHeight: '100%'
    },
    ...maxHeight && { maxHeight }
  })
}));
